import { AnyAction, configureStore } from '@reduxjs/toolkit'
import logger from 'redux-logger'
import { ThunkAction } from 'redux-thunk'
import { resetActiveEntityOnChange } from 'src/v3/create/create.slice'
import { fetchClassesOnSectionChange as _fetchClassesOnSectionChange } from 'src/v3/self-paced/self-paced.slice'
import { fetchEntitiesOnUsersFetched } from 'src/v3/admin/admin.slice'
import { validateProfileOnChange } from 'src/v3/classroom/classroom.slice'
import { resetCreateEntityOnEdit } from 'src/v3/create/create.middleware'
import { listenerMiddleware } from 'src/v3/events/events.middleware'

import rootReducer, { RootState } from './root-state'

export type Status = 'uninitialized' | 'pending' | 'fulfilled' | 'rejected'

export const store = configureStore({
  reducer: rootReducer,
  middleware:
    import.meta.env.VITE_LOG_LEVEL === 'debug'
      ? (getDefaultMiddleware) =>
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          getDefaultMiddleware().concat([
            _fetchClassesOnSectionChange,
            resetActiveEntityOnChange,
            resetCreateEntityOnEdit,
            fetchEntitiesOnUsersFetched,
            validateProfileOnChange,
            logger,
            listenerMiddleware.middleware,
          ])
      : (getDefaultMiddleware) =>
          getDefaultMiddleware().concat([
            _fetchClassesOnSectionChange,
            resetActiveEntityOnChange,
            resetCreateEntityOnEdit,
            fetchEntitiesOnUsersFetched,
            validateProfileOnChange,
            listenerMiddleware.middleware,
          ]),
})

export type AppThunk = ThunkAction<
  Promise<void> | void,
  RootState,
  unknown,
  AnyAction
>
export type AppRootState = RootState
export type AppDispatch = typeof store.dispatch
